const paths = {
    home: '/',
    about: '/about',
    contact: '/contact',
    search: '/search',
    stores: '/stores',
    detail: '/store/:shopName',
    area: '/area/:nameArea',
    allAreas: '/allAreas',
    explore: '/explore',
    exploreDetail: '/explore/:nameDetail',
    saved: '/saved',
    notification: '/notification/:notificationId',
    terms: '/terms',
    policy: '/policy',
    map: '/map',
    error: '*',
};

export default paths;
